import {Dropdown, DropdownItem, IconButton} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface CommentCardItemActionsProps extends TestIdProps {
  id: string;
  isDeleteCommentLoading?: boolean;
  isEditCommentLoading?: boolean;
  onDelete?: (id: string) => void;
  onEditClick?: (id: string) => void;
  isDeleteDisabled?: boolean;
  isEditDisabled?: boolean;
}

export function CommentCardItemActions(props: CommentCardItemActionsProps) {
  return (
    <Dropdown
      isLazy
      lazyBehavior="unmount"
      placement="bottom-end"
      strategy="fixed"
      boundary="scrollParent"
      dropdownControl={
        <IconButton icon="navigation/more_vert" data-testid="button-secondaryActions-more" />
      }
      data-testid={suffixTestId('comment-actions', props)}
    >
      <Show when={isNotNil(props.onEditClick)}>
        <DropdownItem
          key="comment-actions-edit"
          label={i18n.t('general.actions.edit')}
          isLoading={props.isEditCommentLoading}
          onClick={() => props.onEditClick?.(props.id)}
          isDisabled={props.isEditDisabled}
          data-testid={suffixTestId('comment-actionEdit', props)}
        />
      </Show>
      <Show when={isNotNil(props.onDelete)}>
        <DropdownItem
          key="comment-actions-delete"
          label={i18n.t('general.actions.delete')}
          isLoading={props.isDeleteCommentLoading}
          onClick={() => props.onDelete?.(props.id)}
          isDisabled={props.isDeleteDisabled}
          data-testid={suffixTestId('comment-actionDelete', props)}
        />
      </Show>
    </Dropdown>
  );
}
